<shell-layout [error_identity]="true">
  <div class="flex flex-col items-center">
    <img class="w-64" src="assets/img/errors/error__out-office.svg" alt="Error" />

    <ui-text color="blue-500" size="h3" weight="semibold" align="center" class="mt-6">
      ¡Lamentamos que no aproveches esta oportunidad!
    </ui-text>

    <ui-text color="blue-300" align="center" class="mt-3">
      Pero tranquilo, puedes volver a solicitar un préstamo por este medio en 24 horas o puedes
      acercarte a la agencia más cercana a solicitar uno.
    </ui-text>

    <ui-button
      (clicked)="closeModal()"
      class="mt-6"
      type="primary"
      label="Ir a la página principal"
    ></ui-button>
  </div>
</shell-layout>
